export default function WaveDivider() {
  return (
    <div className="w-full overflow-hidden bg-[#fff]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="w-full h-auto"
      >
        <path
          fill="#fdf5e6"
          fillOpacity="1"
          d="M0,224L120,197.3C240,171,480,117,720,112C960,107,1200,149,1320,170.7L1440,192L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"
        ></path>
      </svg>
    </div>
  );
}
